<template>
  <div class="products-services">
    <!-- 页面介绍部分 -->
    <section class="hero-section">
      <div class="hero-content">
        <h1 class="hero-title">{{ sectionTitle }}</h1>
        <p class="hero-subtitle">{{ sectionDescription }}</p>
        <div class="title-underline"></div>
        <div class="hero-decoration">
          <div class="decoration-line"></div>
          <div class="decoration-circle"></div>
          <div class="decoration-line"></div>
        </div>
      </div>
      <div class="hero-background">
        <div class="floating-element element-1"></div>
        <div class="floating-element element-2"></div>
        <div class="floating-element element-3"></div>
      </div>
      
      <div class="scroll-indicator">
        <div class="scroll-arrow">↓</div>
        <span>滚动查看业务</span>
      </div>
    </section>

    <!-- 业务类别列表 -->
    <BusinessCategory
      v-for="(category, index) in categories"
      :key="index"
      :title="category.title"
      :description="category.description"
      :services="category.services"
      :category-index="index + 1"
    />
  </div>
</template>

<script>
import BusinessCategory from '@/components/BusinessCategory.vue';

export default {
  name: 'Products',
  components: {
    BusinessCategory
  },
  data() {
    return {
      sectionTitle: "业务矩阵",
      sectionDescription: "盛世文脉科技致力于为遗产保护与传承提供全方位的数字化解决方案，涵盖文物数字化采集、高新材料仿真孪生、文博元宇宙智能展陈、文物智能化安全管理、大数据与人工智能创新应用、文化学术科研与教育支持以及文化IP运营推广等七大核心业务领域。",
      categories: [
        {
          title: "一. 文物数字化采集与建模",
          description: "运用先进的数字化技术对文物进行高精度采集和三维建模，为文物保护、研究和展示提供数字化基础。",
          services: [
            {
              title: "1. 文物三维扫描与建模",
              description: "利用业界领先的激光扫描、摄影测量等多种技术对文物进行高精度三维扫描，专业建模师将采集数据重建为超精细的三维模型，实现文物的数字化孪生，为研究分析、修复展示及教育提供生动直观的素材。"
            },
            {
              title: "2. 虚拟修复",
              description: "通过数字化技术模拟文物修复全过程，使得文物即使在物理损坏的情况下，也能以虚拟方式恢复其原貌。"
            },
            {
              title: "3. 文物数字档案",
              description: "为文物建立详尽的数字档案，记录其当前状态、历史痕迹以及修复过程等，方便后续的管理和保护。"
            }
          ]
        },
        {
          title: "二. 高新材料仿真孪生与修复",
          description: "运用3D打印技术实现文物精确复制、高效修复、虚拟复位及跨地域展出，助力文物保护与传播。创新采用复合材料（如玻璃纤维、陶瓷复合材料等）、树脂、聚乳酸（PLA）等新材料，进行文物的高还原复制，打印并修复文物的缺失或损坏部分。采用三维打印技术高效省时，尤其是陶瓷3D打印技术已广泛应用于修复陶瓷文物，比起传统的文物复制与修复方式，有着十分显著的优点。",
          services: [
            {
              title: "1. 文物复制和修复",
              description: "利用3D打印技术，实现文物的毫米级精确复制与精细化修复。不仅可加速文物修复的进程，显著提升修复工作的精确度与质量，复制的高保真还原品还能在展览中得以广泛应用，既可以展示文物的原始风貌，又有效减少了对珍贵文物本体的物理接触与潜在损伤，确保了文化遗产的长远保存。采用三维打印技术高效省时，尤其是陶瓷3D打印技术已广泛应用于修复陶瓷文物，比起传统的文物复制与修复方式，有着十分显著的优点。"
            },
            {
              title: "2. 高新材料仿真孪生",
              description: "基于高新材料既能保证高强度，又具备与原文物相似的物理和化学特性。具备多种仿真材料可选，包括但不限于：（1）复合材料：采用复合材料（如玻璃纤维、陶瓷复合材料等）打印文物的缺失部分，这些材料既能保证高强度，又可具备与原文物相似的物理和化学特性。（2）树脂与塑料：在某些文物修复中，树脂、聚乳酸（PLA）等材料可以打印文物的损坏部分，形态与原文物高度相似，并且具备较高的可塑性。（3）陶瓷材料：陶瓷3D打印技术已广泛应用于修复陶瓷文物，打印出的陶瓷零部件可以与原文物的风格、材质等进行匹配，达到理想的修复效果。"
            },
            {
              title: "3. 不可移动文物的跨地区展出",
              description: "针对体量庞大或环境敏感型的不可移动文物，通过3D打印复制服务，使得珍贵文物能够以高仿真度的复制品形态，在全国其他不同区域以及全球范围内进行巡回展出。这能有效打破地域限制，让更多人有机会近距离感受遗产文化的魅力，实现文物价值的最大化传播。"
            },
            {
              title: "4. 流失文物虚拟复位",
              description: "针对各类由于历史原因流失在海外的文物，采用三维扫描、数据建模、图像识别、大数据分析、虚拟拼接等数字化技术，结合历史文献档案与文史、考古、古建领域考古专家的指导，能精确复原其原貌，实现文物在虚拟空间的数字化回归。后续可通过数字博物馆、云展览等形式，使这些流散的文化瑰宝得以在数字世界中复位。"
            }
          ]
        },
        {
          title: "三. 文博元宇宙智能展陈",
          description: "文博元宇宙智能展陈将融合全息线上博物馆与沉浸式线下展览，打造虚实结合的文化体验，让观众随时随地穿越时空，感受历史文化魅力。",
          services: [
            {
              title: "1. 文博展陈设计",
              description: "致力于提供全面的专题展览解决方案，结合实物展示、多媒体内容以及数字内容交互程序的设计与实施，涵盖实地展览设计、数字内容制作、影视动画、工程及系统开发等多方面业务，为教育机构和公众提供丰富的文化学习资源，增强展览的教育性和趣味性。"
            },
            {
              title: "2. 全息线上博物馆",
              description: "构建多平台兼容的数字孪生博物馆，提供360°全景漫游、虚拟讲解等服务，通过数字化科技扩大文物的线上展示空间，让全球观众不受地域限制，随时随地享受沉浸式的观展体验。"
            },
            {
              title: "3. 沉浸式线下展览",
              description: "将高精度的博物馆、大遗址、石窟寺、古建筑的数字孪生数据，融合MR、全息投影、裸眼3D、体感互动、数字投影等技术与实体展陈结合，在展览中展示文物的历史故事和背景，打造虚实结合的互动体验，让观众在虚拟与现实交错的文化元宇宙中穿越时空，增强互动参与感，感受历史文化的魅力。"
            },
            {
              title: "4. 线上线下融合的展览平台",
              description: "构建云基数据互联平台，确保线上线下的展览内容实时同步与数据流通。配备智能化展示设备，实时更新展品信息、提供多语言解说，也便于快速实施展品信息变动、活动调度及反馈搜集，为观众提供连贯一致且高效的展览体验。"
            },
            {
              title: "5. 智慧导览系统",
              description: "为展览定制打造支持语音导航、AI虚拟人导览、AR增强现实导览等多种功能的导览系统，让观众在轻松愉快的氛围中探索博物馆的每一个角落。支持收集观众反馈数据，为博物馆的运营和服务优化提供有力支持，进一步提升观众参观体验。"
            },
            {
              title: "6. 文创产品与旅游开发",
              description: "依托文化遗产数字资源，开发文创产品，进行文化旅游与研学产品等开发，提升遗产文化社会影响力和经济效益。"
            },
            {
              title: "7. 创意文博应用开发",
              description: "推出以文物为灵感的互动应用程序与教育游戏，例如文物复原拼图、历史角色探险游戏、数字收藏品等，增加线上互动，提高商业转化率。"
            }
          ]
        },
        {
          title: "四. 文物智能化安全管理",
          description: "文物智能化安全管理业务涵盖智能管理平台、移动端管理工具、数据管理安防体系及智慧展览管理，实现对文物及其数字资源的全方位智能化监控、维护、管理与保护，确保文物数据安全并提升管理效能。",
          services: [
            {
              title: "1. 文物智能管理平台",
              description: "结合物联网技术，建立文物的智能管理平台，实现对文物的实时监控、维护和管理。集成多种传感器和监控设备，对文物的环境参数（如温度、湿度、光照等）进行实时监测，一旦发现异常立即触发预警机制，确保文物处于最佳保存状态。"
            },
            {
              title: "2. 移动端管理工具",
              description: "通过开发手机或平板等设备上的移动应用，为文物管理人员提供便捷的文物信息查看和管理功能。管理人员可以随时随地查看文物的当前状态、维护记录、预警信息等，并进行相应的信息更新和管理操作，提高工作效率。"
            },
            {
              title: "3. 数据管理安防体系",
              description: "采用高效、安全存储、检索保护技术，确保文物数字资产的高效、安全管理和异地灾备。通过采用加密技术、访问控制、数据备份等多种手段，有效防范数据泄露、篡改和丢失等风险，保障文物数字资产的安全性和完整性。"
            },
            {
              title: "4. 数据安全与版权保护",
              description: "利用区块链加密、数字水印、文物数据确权追溯等技术，保障文物数据的版权和所有权，防止数据流转过程中未授权使用等情况发生。"
            },
            {
              title: "5. 智慧展览管理",
              description: "可根据用户实际需求，搭建包含展览策划、场馆运营与观众互动等功能的一站式管理系统。该系统能够智能化分析观众行为数据，如参观路径、停留时间、互动反馈等，从而精准把握观众需求和偏好，实现展览活动的智能化调度与个性化服务。同时，系统还能提供丰富的展览策划工具和场馆运营支持功能，助力提升参观体验和管理效率。"
            }
          ]
        },
        {
          title: "五. 大数据与人工智能的创新应用",
          description: "利用大数据与AI技术，创新构建遗产文化数字资源库，实现文物智能监测、深度分析与个性化教育体验服务。",
          services: [
            {
              title: "1. 遗产文化数字资源库建设",
              description: "采集并整合文物的高清图像，高保真三维模型与详尽的文献背景等全面综合的资料，进行大数据规范编制、平台建设和大数据计算等工作，构建完善的文化遗产数字资源库，致力于推动文化资源的创造性和转化与创新性发展。"
            },
            {
              title: "2. 文保预测性监测系统",
              description: "为历史遗迹与珍贵文物量身定制全方位的监测与保护策略，并搭建预测性维护警示系统。采用最前沿的物联网(IoT)与人工智能(AI)技术，通过部署精密传感器网络，实时监测温湿度、光照、振动等环境因素，AI算法即时分析数据，预警潜在风险。"
            },
            {
              title: "3. 文物信息大数据分析处理",
              description: "依托强大的数据分析平台，对大量文物数字化信息进行分析处理，深入挖掘文物数据背后的历史脉络、艺术美学、社会影响与文化价值。有效辅助考古发掘及文物修复，并为文物的深度开发利用与多元化文创产品的孵化提供科学依据。"
            },
            {
              title: "4. 个性化文化遗产教育服务",
              description: "通过智能算法模型，精准描绘受众画像，指导文创产品定位与市场策略，提供个性化的文化遗产教育体验服务，如XR互动教学、3D打印课程等，确保每项创意都能精准触达目标群体，实现文化与市场的高效对接，促进文化传承与经济价值的双重提升。"
            }
          ]
        },
        {
          title: "六. 文化学术科研与教育支持",
          description: "盛世文脉凭借顶尖科研团队，提供文物保护技术培训与咨询，策划考古研学与社会教育活动，并携手合作方与国内外专业学术科研机构开展深度合作，培养公众科学素养与人文精神，助力考古资源的有序开放共享和参与主体的多元化。",
          services: [
            {
              title: "1. 顶尖科研团队",
              description: "盛世文脉科技的初创团队汇聚了当前国内文物数字化领域的精英力量，致力于在交叉学科视角下持续研发行业领先的文物保护与利用技术，以高精尖数字化技术推动行业技术和理念的进步。"
            },
            {
              title: "2. 专业培训与咨询服务",
              description: "盛世文脉科技拥有一流学术领域专家和一线技术骨干组成的团队，可为从业人员及爱好者提供行业最新的理论知识与实践专业培训课程，提升其保护技能和技术水平，持续为文博行业培养输送新型人才，并提供文物保护相关的技术咨询、项目申报和解决方案支持。"
            },
            {
              title: "3. 合作推动与交流平台",
              description: "盛世文脉和省内外高校、文博单位、企业、科研院所以及全球考古文博机构、国际组织等均保持密切的合作关系，联合合作方共同搭建历史学、考古学、信息技术、材料学等多学科的行业知识共享平台，通过线上、线下多渠道不定期开展关于学术前沿、人才培养、机构建设等方面的经验分享，携手推动跨学科、跨专业、跨领域文物保护深入协同合作。"
            },
            {
              title: "4. 考古研学产品定制",
              description: "基于客户自身的资源价值特点，推出定制化的专属研学产品和服务，针对不同年龄层次、知识背景的对象，开发设计不同类型富有启发性、探索性、实践性、体验性的系列专题课程，提供参观、课堂、实践、模拟、竞赛以及线上等各种形式的课程服务。在安全性、研究性、公益性、规范性原则之下开展考古研学活动，以精心打造的优质课程内容与高质量配套服务有效转化考古成果和历史研究成果，使广大公众获得深度体验和实践教育，更好的促进考古研学的发展以及满足社会公众的期盼与要求。"
            }
          ]
        },
        {
          title: "七. 文化IP运营和宣传推广",
          description: "通过数字化转型商业化策略，将遗产文化转化为具有持久价值的知识产权。这一过程赋予遗产文化新的价值，使文化IP的独特元素成为可识别、可追踪、可变现的资产。通过品牌营销推广和产业化发展，这些珍贵的文化资源得以焕发新的活力。盛世文脉科技在文化资源商业化过程中，高度重视文化IP的保护。对文化失真、知识产权纠纷、投入产出不平衡等问题进行严格把控，通过提前界定、合作监督和质量检验，为文化IP授权保驾护航。",
          services: [
            {
              title: "1. 多人VR、多类型互动体验",
              description: "借助高精度的3D扫描和VR技术，在虚拟空间生动再现历史原貌，让体验者通过互动游戏形式穿越时空。比如多人VR沉浸式体验能让多名用户同时进入虚拟场景，实现实时互动和交流，创造独特的社交体验。能实现虚拟导览、历史场景重现、文物修复体验、文化故事演绎等多种互动形式，满足不同用户需求。通过将严谨的文化内容与趣味性游戏体验相结合，既确保知识传递的准确性，又增强学习的趣味性，同时突破地理限制，实现文化体验的跨区域共享。"
            },
            {
              title: "2. 游戏与影视产业应用",
              description: "文化遗产与游戏与影视产业结合具有巨大的商业潜力。文化遗产中的建筑、历史人物和神话传说等元素可以被提取，并融入到游戏与影视的世界观、角色、场景设计中。盛世文脉作为专业团队，严格把控游戏化过程中的文化失真、知识产权纠纷、投入产出不平衡等问题，通过提前界定、合作监督和质量检验，为文化IP授权担保。"
            },
            {
              title: "3. 高端研学课程与教育衍生服务",
              description: "依托盛世文脉科技的专业学术资源，针对不同人群，分别设计趣味性和深度化等定制化课程，满足不同高端群体需求，能系统展示传统文化精髓，提供结合多种学习形式的深入体验。并且随着教育领域对创新教学工具的需求增加，以及对遗产文化教育重视程度的提升，新型的3D打印文化教具市场具有巨大的潜力，比如古建筑构件与等比缩小模型等。学校、博物馆、文化机构等都可能成为3D打印教育产品或服务的潜在客户。"
            },
            {
              title: "4. 综合性文旅IP数字装置",
              description: "结合遗产文化数字资源，集三维打印技术、声光技术等数字新技术于一体的综合性数字化装置，能帮助商场与景点增强消费体验，吸引消费群体，促进销售，因此在商场布展、旅游展览中有极高的商业需求性。"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.products-services {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
  line-height: 1.7;
  padding: 0;
  min-height: 100vh;
  background: #f8fafc;
  --primary-color: #667eea;
  --secondary-color: #764ba2;
  --accent-color: rgba(255, 255, 255, 0.1);
  --text-color: white;
  --border-color: rgba(255, 255, 255, 0.2);
}

/* Hero Section */
.hero-section {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  overflow: hidden;
}

.hero-content {
  text-align: center;
  color: var(--text-color);
  max-width: 900px;
  padding: 2rem;
  position: relative;
  z-index: 2;
}

.hero-title {
  font-size: clamp(2.5rem, 6vw, 4.5rem);
  font-weight: 700;
  margin: 0 0 1rem 0;
  line-height: 1.3;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
  letter-spacing: 2px;
  background: linear-gradient(135deg, #ffffff 0%, #f0f8ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: titleSlideIn 1s ease-out;
}

.hero-subtitle {
  font-size: clamp(1rem, 2.5vw, 1.3rem);
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 2rem 0;
  line-height: 1.6;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
  animation: subtitleSlideIn 1s ease-out 0.3s both;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

@keyframes titleSlideIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes subtitleSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title-underline {
  width: 100px;
  height: 4px;
  background: linear-gradient(90deg, transparent, white, transparent);
  margin: 1.5rem auto;
  border-radius: 2px;
  animation: underlineExpand 1s ease-out 0.5s both;
}

@keyframes underlineExpand {
  from {
    width: 0;
    opacity: 0;
  }
  to {
    width: 100px;
    opacity: 1;
  }
}

.hero-decoration {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}

.decoration-line {
  width: 60px;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
  border-radius: 1px;
}

.decoration-circle {
  width: 12px;
  height: 12px;
  border: 2px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.floating-element {
  position: absolute;
  border-radius: 50%;
  background: var(--accent-color);
  animation: float 6s ease-in-out infinite;
}

.element-1 {
  width: 100px;
  height: 100px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.element-2 {
  width: 150px;
  height: 150px;
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.element-3 {
  width: 80px;
  height: 80px;
  bottom: 20%;
  left: 20%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

.scroll-indicator {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.8rem;
  animation: bounce 2s infinite;
  z-index: 2;
}

.scroll-arrow {
  font-size: 1.2rem;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { 
    transform: translateX(-50%) translateY(0); 
  }
  40% { 
    transform: translateX(-50%) translateY(-8px); 
  }
  60% { 
    transform: translateX(-50%) translateY(-4px); 
  }
}

/* 统一业务类别样式 */
:deep(.business-category) {
  background: var(--accent-color);
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .products-services {
    padding-top: 70px;
  }
  
  .hero-content {
    padding: 1rem;
  }
  
  .decoration-line {
    width: 40px;
  }
  
  .floating-element {
    display: none;
  }
}

@media (max-width: 480px) {
  .hero-decoration {
    gap: 0.5rem;
  }
  
  .decoration-line {
    width: 30px;
  }
  
  .decoration-circle {
    width: 8px;
    height: 8px;
  }
}
</style>